// mockUp custom translator loader service
//
// It is used for loading translations in a custom way provided by the application,
// rather than using locally stored translations in folder ./assets/i18n

import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {TranslateLoader} from '@ngx-translate/core';
import {GeneralService} from "../../services/crud/general.service";
import {TranslationService} from 'src/app/services/translation-service';

///////////////////////////////////////////////////////////////
@Injectable({
	providedIn: 'root'
})
export class OEMTranslatorLoaderService implements TranslateLoader
{
	// currLang: string;

	constructor(private http: HttpClient,
				private httpService: TranslationService)
				//private httpService: GeneralService)
	{
		// this.currLang = "en";
	}

	// method used by pipes for translating words
	//
	// according to 'langId' (language id e.g. 'en', 'it', etc. ), it will return all available translations for that language 'id'
	getTranslation(langId: string): Observable<any>
	{
		return new Observable<any>((observer) =>
		{
			//Fetch all translation key and value
			this.httpService.getLanguage(langId).subscribe(res =>
			{
				observer.next(res);
				observer.complete();
			})
		})
	}

}


